import { render, staticRenderFns } from "./sub_index.vue?vue&type=template&id=f50b8d4a&scoped=true"
import script from "./sub_index.vue?vue&type=script&lang=js"
export * from "./sub_index.vue?vue&type=script&lang=js"
import style0 from "./sub_index.vue?vue&type=style&index=0&id=f50b8d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50b8d4a",
  null
  
)

export default component.exports